import React, { useContext } from "react";
import type { Environment } from "components/Environment/utils/types";
import { getEnvironmentStatus } from "components/Environment/utils/environtmentUtils";
import { resolveNetworkMemberType } from "components/Environment/Networks/networkMode";
import { NetworkAddressCard } from "components/NodeDetail/shared/NetworkAddressCard";
import { NetworkModeSummary } from "components/Environment/shared/NetworkModeSummary";
import { OrgContext } from "contexts/OrgContext";
import { WorkspaceStatus } from "models/Workspace.model";
import { isOrgAdminOrMaintainerRole } from "utils/roleUtils";
import { useEnvironmentNetworkAccess } from "hooks/environment/useEnvironmentNetworkAccess";
const EnvironmentNetworkSection: React.FC<{
  environment: Environment;
}> = ({ environment }) => {
  const orgContext = useContext(OrgContext);
  const {
    isLoadingNetworkInfo,
    isNetworkInfoError,
    environmentNetworkInfo,
    setNetworkMemberType,
  } = useEnvironmentNetworkAccess(environment);
  const resolvedMemberType = resolveNetworkMemberType(
    environmentNetworkInfo?.networkMemberType,
  );
  const canChangeNetworkMode = isOrgAdminOrMaintainerRole(
    orgContext.activeOrgRole,
  );
  const isDeleting =
    getEnvironmentStatus(environment) === WorkspaceStatus.Deleting;

  return (
    <>
      <NetworkModeSummary
        name={environment.name || "this environment"}
        memberType={resolvedMemberType}
        unavailable={isNetworkInfoError}
        disabled={isDeleting || isLoadingNetworkInfo}
        onSetMode={
          canChangeNetworkMode && environment.environment_id
            ? setNetworkMemberType
            : undefined
        }
      />
      <NetworkAddressCard
        localIp={environmentNetworkInfo?.meshIpAddress}
        privateDns={environmentNetworkInfo?.meshDnsName}
        unavailable={isNetworkInfoError}
      />
    </>
  );
};

export default EnvironmentNetworkSection;
